/**
 * Rapor sayı biçimleyicileri. Yaprak modüldür (görünüm modeli dosyalarına bağlanmaz):
 * `event-report-sections-view` ile `event-report-ticket-rows` ikisi de buradan alır, aralarında
 * çalışma zamanı döngüsü kurulmaz (Metro "Require cycle").
 */
/**
 * Bastırılmış hücrenin metni İKİ türlüdür (QA B3b P2-2): `fewer_than_min` gerçekten eşiğin
 * altındadır ve "5'ten az" yazar; `hidden` tamamlayıcı bastırmadır, gerçek değer eşiğin ÜSTÜNDE
 * olabilir (ölçüldü: 6), "5'ten az" yazmak yanlış sayı iddiasıdır, "Gösterilmez" yazar.
 * Web, mobil ve PDF bu tek işlevden okur.
 */
export function eventReportCountText(t, count, min) {
    if (count.suppression === 'hidden')
        return t.t('analytics.report.countHidden');
    if (count.value === null)
        return t.t('analytics.report.fewerThanMin', { min: String(min) });
    return t.formatNumber(count.value);
}
const SUMMARY_TEXT = {
    few_responses: 'analytics.report.summaryFewResponses',
    unavailable: 'analytics.report.countHidden',
    no_survey: 'analytics.report.comparison.noSurvey',
};
/**
 * ANKET ÖZETİ DEĞERİ YAZILMADIĞINDA METNİ (kullanıcı kararı 30.10.2026 akşam). Hâli sunucu
 * verir (`EventReportSummaryState`); rapor, PDF, mobil rapor, karşılaştırma, panel sütunu ve
 * "Rapor hazır" e-postası bu TEK eşlemeden okur: bastırılmış özet "Az yanıt, gösterilmez",
 * anketsiz etkinlik "Anket yok", doğrulanamayan değer "Gösterilmez". `shown` için `null`
 * (çağıran değeri biçimler).
 */
export function eventReportSummaryText(t, state) {
    return state === 'shown' ? null : t.t(SUMMARY_TEXT[state]);
}
export function eventReportPercent(t, value) {
    return t.formatNumber(value / 100, { style: 'percent', maximumFractionDigits: 0 });
}
//# sourceMappingURL=event-report-format.js.map